import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "@copro/api";
import { useSpace } from "../../../hooks/useSpace";
import { keys } from "./keys";

export function usePostSubjectTask(subjectId: string) {
  const queryClient = useQueryClient();
  const { currentSpace } = useSpace();

  return useMutation({
    mutationFn: async ({ title, position }: { title: string; position: number }) => {
      const { data, error } = await apiClient
        .from('subject_tasks')
        .insert({
          subject_id: subjectId,
          title,
          state: 'pending',
          position,
        })
        .select()
        .single();

      if (error) throw error;
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: keys.getSubjectTasks(subjectId) });
      if (currentSpace?.id) {
        queryClient.invalidateQueries({ queryKey: keys.pendingSubTopics(currentSpace.id) });
        queryClient.invalidateQueries({ queryKey: keys.openTasks(currentSpace.id) });
      }
    },
  });
}
